import React from 'react';
import { cn } from '../../lib/utils';

/**
 * OrkaIcon — semantic icon wrapper (Code Reference §2.2).
 *
 * Wraps any lucide-react icon with consistent sizing, accessible labels, and
 * intent-coloured tinting. Product components MUST use this rather than
 * importing lucide directly so we can swap icons or sizes globally.
 *
 *   <OrkaIcon icon={Clock} size="sm" intent="info" label="Time" />
 */
const SIZE_PX = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
};

const INTENT_CLASSES = {
  primary: 'orka-text-primary',
  secondary: 'orka-text-secondary',
  tertiary: 'orka-text-tertiary',
  success: 'orka-text-success',
  warning: 'orka-text-warning',
  danger: 'orka-text-danger',
  info: 'orka-text-info',
  intent: 'orka-text-intent',
};

export function OrkaIcon({
  icon: Icon,
  size = 'md',
  intent = 'secondary',
  label,
  className,
  ...rest
}) {
  if (!Icon) return null;
  const px = SIZE_PX[size] || SIZE_PX.md;
  return (
    <Icon
      width={px}
      height={px}
      strokeWidth={1.75}
      role={label ? 'img' : 'presentation'}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : 'true'}
      className={cn(INTENT_CLASSES[intent] || INTENT_CLASSES.secondary, 'shrink-0', className)}
      {...rest}
    />
  );
}

export default OrkaIcon;
